import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import H4 from 'UIComponents/elements/headings/H4';
import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import { TABS } from 'collaboration-sidebar/constants/tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "Tab__StyledUIFlex",
  componentId: "u7xhba-0"
})([".hs-private.hs-private.hs-private &{height:100%;}"]);
const TabHeaderWrapper = styled(UIFlex).attrs({
  align: 'center'
}).withConfig({
  displayName: "Tab__TabHeaderWrapper",
  componentId: "u7xhba-1"
})([".hs-private.hs-private.hs-private &{padding:15px 15px;flex-grow:0;border-bottom:1px solid ", ";min-height:64px;}"], BATTLESHIP);
const StyledUIBox = styled(UIBox).withConfig({
  displayName: "Tab__StyledUIBox",
  componentId: "u7xhba-2"
})([".hs-private.hs-private.hs-private &{min-height:0%;overflow-y:auto;position:relative;}"]);
const COMMENT_STYLE = {
  background: OLAF,
  /**
   * Prevents comment tooltips from overflowing the tab header.
   */
  zIndex: 1200
};
export default function Tab({
  heading,
  actions,
  children,
  showHeader = true,
  tab
}) {
  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    direction: "column",
    align: "stretch",
    children: [showHeader && /*#__PURE__*/_jsxs(TabHeaderWrapper, {
      style: tab === TABS.COMMENTS ? COMMENT_STYLE : undefined,
      children: [/*#__PURE__*/_jsx(H4, {
        className: "m-bottom-0 flex-grow-1",
        children: heading
      }), actions]
    }), /*#__PURE__*/_jsx(StyledUIBox, {
      grow: 1,
      children: children
    })]
  });
}